import React from 'react';

import { Box, Button, Typography } from '@material-ui/core';
import { AiOutlineCheckCircle } from 'react-icons/ai';

import { COPY } from '../config';
import useStyles from '../styles';

interface Props {
  isCSCS: boolean;
  onAddAnother: () => void;
  onDone: () => void;
}

export const SuccessPhase = ({ isCSCS, onAddAnother, onDone }: Props) => {
  const classes = useStyles();

  return (
    <Box display="flex" flexDirection="column" gridGap={16} alignItems="center" textAlign="center">
      <AiOutlineCheckCircle size="48px" className={classes.successIcon} />

      <Box>
        <Typography variant="h6">
          {isCSCS ? COPY.success.cscsTitle : COPY.success.qualificationTitle}
        </Typography>
        <Typography variant="body2" color="textSecondary">
          {isCSCS ? COPY.success.cscsSubtitle : COPY.success.qualificationSubtitle}
        </Typography>
      </Box>

      <Box className={classes.noteBox}>
        <Typography variant="subtitle2">{COPY.success.prompt}</Typography>
        <Typography variant="body2" color="textSecondary">
          {COPY.success.promptSubtitle}
        </Typography>
      </Box>

      <Box display="flex" flexDirection="column" gridGap={12} width="100%">
        <Button variant="contained" color="primary" size="large" onClick={onAddAnother}>
          {COPY.success.addAnother}
        </Button>
        <Button variant="outlined" size="large" onClick={onDone}>
          {COPY.success.done}
        </Button>
      </Box>
    </Box>
  );
};
